import { Controller } from "@hotwired/stimulus"

// Toggles dark/light mode by flipping `.dark` on <html> and persisting to localStorage.
// Usage: <button data-controller="theme-toggle" data-action="theme-toggle#toggle">
export default class extends Controller {
  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    localStorage.theme = isDark ? "dark" : "light"
  }
}
